/** Module bridge so non-React utils (Navigator, toastUtils) use the same Snackbar notify. */
let notifyImpl = null;

export function registerNotify(fn) {
  notifyImpl = typeof fn === "function" ? fn : null;
}

export function bridgeNotify(message, severity = "success") {
  if (!message) return;
  if (notifyImpl) {
    notifyImpl(String(message), severity);
    return;
  }
  if (typeof console !== "undefined") {
    console[severity === "error" ? "error" : "log"](message);
  }
}
